module.exports = __webpack_public_path__ + "img/OSINT LAB REPORT small.579b5889.png";